import { useEffect } from "react";

import { initClientErrorCapture } from "@/lib/initClientErrorLogger";

/**
 * ADDITION — mounts the platform-wide client error/warning capture.
 *
 * Renders nothing, exactly like `LiveOrdersBridge` and `OfflineOrdersBridge`.
 * The install is idempotent, so React 18's double-invoked effect in development
 * cannot double-patch `console.error`.
 *
 * It runs from an EFFECT rather than at module scope for the same reason
 * `Analytics` does: module scope executes during SSR, and `window`/`console`
 * patching belongs to the browser. The cost is that a throw during the very
 * first client render is missed here (the Vite apps install before render and do
 * not have that gap) — an acceptable trade against touching the server bundle.
 *
 * Placed high in `_app`, above the theme, so it is armed before any route
 * mounts. See `lib/clientErrorLogger.ts` for the no-recursion / no-spam /
 * no-self-harm rules, and `lib/initClientErrorLogger.ts` for the deliberately
 * strict rule about what is sent for a CUSTOMER (no phone, no name, no order).
 */
export default function ClientErrorCapture() {
  useEffect(() => {
    initClientErrorCapture();
  }, []);
  return null;
}
